<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <Navbar v-if="currentUser"></Navbar>
    <div class='container mt-5 '><router-view/></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Navbar from './components/Navbar.vue'
export default {
  name: 'app',
  components: { Navbar },
  computed: {
    ...mapState(['currentUser', 'userProfile'])
  }

}
</script>


<style>

</style>
